import { render, staticRenderFns } from "./websiteAdvantages.vue?vue&type=template&id=0fb23a11&scoped=true&"
import script from "./websiteAdvantages.vue?vue&type=script&lang=js&"
export * from "./websiteAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./websiteAdvantages.vue?vue&type=style&index=0&id=0fb23a11&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb23a11",
  null
  
)

export default component.exports